var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01ResultadosSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.4 19.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.57,218.32H418.8c-.08,0-.11,0-.14-.08a2.18,2.18,0,0,0-2-1.2,2.16,2.16,0,0,0-2,1.2.12.12,0,0,1-.14.08h-2.77a2.83,2.83,0,0,0-.62.06,2.18,2.18,0,0,0-1.67,2.2v13.3a2.17,2.17,0,0,0,2.27,2.27h9.85a2.17,2.17,0,0,0,2.27-2.27q0-6.65,0-13.28A2.2,2.2,0,0,0,421.57,218.32Zm-5.95.68a1.08,1.08,0,0,1,1-.79h0a1.09,1.09,0,0,1,1,.79.61.61,0,0,0,.67.5h.72v.09a2.31,2.31,0,0,1,0,.38,1,1,0,0,1-1,.83H415.2a1,1,0,0,1-1-1v-.31H415A.61.61,0,0,0,415.62,219Zm-2.5,1.37a2.13,2.13,0,0,0,2,1.61c1,0,2,0,3,0a2.19,2.19,0,0,0,2.15-2.15v-.33h1.35a1,1,0,0,1,1,1v13.39a1,1,0,0,1-1,1h-10a1,1,0,0,1-1-1.05V220.56a1,1,0,0,1,1.08-1.06H413c0,.07,0,.14,0,.21A4.76,4.76,0,0,0,413.12,220.37Z",
    transform: "translate(-409.46 -217.04)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M415.43,229.94a.6.6,0,0,0,.93,0l.5-.49.8-.78,2-2a.65.65,0,0,0,.23-.59.56.56,0,0,0-.39-.46.63.63,0,0,0-.64.17L417.68,227l-1.78,1.74-.37-.36q-.54-.54-1.08-1a.68.68,0,0,0-.49-.21.53.53,0,0,0-.4.18.6.6,0,0,0,.06.87Z",
    transform: "translate(-409.46 -217.04)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01ResultadosSelect);
export default __webpack_public_path__ + "static/media/01_Resultados_Select.b9ff8a8faf5cdad9b907b64ae0696306.svg";
export { ForwardRef as ReactComponent };